/** @format */

export const EditSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.8942 7.15651L6.42272 12.6266L5.62733 11.8311L5.70945 11.749H4.62782C4.42135 11.749 4.25241 11.58 4.25241 11.3735V10.2917L4.17053 10.3738C4.05955 10.4865 3.97814 10.6226 3.93379 10.7727L3.39462 12.6079L5.22846 12.0681C5.35751 12.0235 5.51471 11.9414 5.62733 11.8311L6.42272 12.6266C6.1787 12.8707 5.87603 13.0514 5.54521 13.1476L2.72194 13.9783C2.52439 14.037 2.31064 13.983 2.16494 13.8164C2.01923 13.692 1.96475 13.4785 2.02289 13.279L2.85333 10.4559C2.95094 10.1251 3.12996 9.82234 3.37421 9.57829L8.84407 4.10676L11.8942 7.15651ZM13.5601 3.36545C14.1466 3.95188 14.1466 4.9037 13.5601 5.49037L12.4245 6.62616L9.37433 3.57594L10.5099 2.44015C11.0965 1.85353 12.0491 1.85353 12.6356 2.44015L13.5601 3.36545Z"
                fill={color}
            />
        </svg>
    );
};
